import { isFeatureEnabled } from 'owa-feature-flags';

export default function isAddinComplianceVerificationEnabled(): boolean {
    return isFeatureEnabled('addin-complianceVerification');
}
